/**
 * @learnzapp/core/qotd — the ONE shared Question-of-the-Day pick + decision.
 *
 * - getDeterministicIndexForDate: the date→index hash both apps' dates.js
 *   re-export, so the daily pick (and the 30-day backfill seed) can never drift
 *   and corrupt the shared apps/{APP}/qotd/{date} doc.
 * - pickDeterministicQuestion / RESOLVE_TODAY_QOTD: the provider-agnostic
 *   decision logic. Firestore I/O and `today` are injected by each app (apps
 *   keep their own reads/writes and their own getTodayLocal). Zero behavior
 *   change — ported faithfully from the already-identical app implementations.
 */
export * from './deterministic';
export * from './resolve';
